import { MouseEvent } from 'react'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'
import { Close } from 'svgIcons'
import {
  GqlInterestedCompaniesDocument,
  useGqlToggleCompanyInterestInMutation,
} from 'generated/graphql'
import { COMPANY_TYPE_LABELS } from '@app.feature/companyInfo/constants/companyType'
import { TCompanyInfoCard } from '@app.feature/companyInfo/main/type/companyInfoCard'
import { getLimitNumText } from 'components/ActivityListCardItem/module/getLimitNumText'
import useErrorSnackbar from 'hooks/useErrorSnackbar'

interface IFProps {
  data: TCompanyInfoCard
}

const CompanyScrapItem = ({ data }: IFProps) => {
  const router = useRouter()
  const { enqueueApolloError } = useErrorSnackbar()

  const [removeCompanyInterestedIn] = useGqlToggleCompanyInterestInMutation()

  const handleClickCard = () => {
    router.push(`/company-info/${data.companyInformationId}`)
  }

  const handleClickDelete = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    removeCompanyInterestedIn({
      variables: {
        input: {
          companyId: data.companyId,
          isInterestedIn: false,
        },
      },
      refetchQueries: [GqlInterestedCompaniesDocument],
      onError: enqueueApolloError,
    })
  }
  return (
    <StyledWrapper onClick={handleClickCard}>
      {data.isHiring && <span className="badge-hiring">채용중</span>}

      <div className="company-logo-wrapper">
        <img src={data.companyLogo} alt={data.companyName} />
      </div>

      <div className="company-info-wrapper">
        <h3 className="company-name">{data.companyName}</h3>
        <div className="company-type">
          <span>{COMPANY_TYPE_LABELS[data.companyType]}</span>
          <span>{data.industryType}</span>
        </div>
        <div className="company-stats">
          <span>
            관심설정 {getLimitNumText({ number: data.likesCount, limit: 9999 })}
          </span>
          <span>
            조회수 {getLimitNumText({ number: data.viewsCount, limit: 9999 })}
          </span>
        </div>
      </div>
      <button type="button" className="close-btn" onClick={handleClickDelete}>
        <Close width={15} height={15} />
      </button>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.li`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: ${theme.isMobile ? '102px' : '125px'};
    background: ${theme.background.bg_8};
    cursor: pointer;
    padding: ${theme.isMobile ? '12px 0' : '16px'};
    position: relative;
    border-bottom: 1px solid ${theme.line.line_3};

    .badge-hiring {
      position: absolute;
      top: 16px;
      left: 16px;
      background: #f46161;
      color: ${theme.background.bg_8};
      font-size: 12px;
      font-weight: bold;
      border-radius: 6px;
      min-width: 44px;
      height: 24px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    ${theme.isMobile &&
    css`
      .badge-hiring {
        top: 12px;
        left: 0px;
        min-width: 37px;
        height: 23px;
        font-size: 11px;
      }
    `}

    .company-logo-wrapper {
      min-width: ${theme.isMobile ? '100px' : '160px'};
      padding: 0 ${theme.isMobile ? '8px' : '16px'};
      > img {
        width: ${theme.isMobile ? '75px' : '120px'};
        height: ${theme.isMobile ? '48px' : '31px'};
        object-fit: contain;
      }
    }

    .company-info-wrapper {
      flex: 1;
      margin-left: 12px;
      min-width: 0;
      .company-name {
        font-size: ${theme.isMobile ? '15px' : '16px'};
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: -0.64px;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .company-type {
        font-size: ${theme.isMobile ? '13px' : '14px'};
        line-height: 1.71;
        letter-spacing: -0.56px;
        margin-bottom: 8px;
        & > span:not(:last-child)::after {
          content: '';
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px;
          width: 1px;
          height: 10px;
          background-color: ${theme.line.line_2};
        }
      }
      .company-stats {
        font-size: 12px;
        color: ${theme.color.text_2};
        letter-spacing: -0.48px;
        & > span:not(:last-child)::after {
          content: '';
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px;
          width: 1px;
          height: 10px;
          background-color: ${theme.line.line_2};
        }
      }
    }

    .close-btn {
      top: 16px;
      right: 16px;
      font-size: 20px;
      color: #bbb;
      cursor: pointer;
      background: transparent;
      border: none;
    }
  `}
`

export default CompanyScrapItem
